import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import PrintData from "components/GenericComponent/PrintData";
import configs from "constants/configs";
import { Cookies } from "react-cookie";
export const BtnInDanhSach = () => {
  const dataSearch = useSelector((state) => state.dataSearchDanhSachThanhLy); //dataSearchTaiSan dinh nghia o rootreducer

  const cookies = new Cookies();
  let link = configs.endPoint;
  var apilink = cookies.get("apilink");
  if (typeof apilink != "undefined" && apilink.length > 0) {
    link = apilink;
  }

  link = link +
    `quan-ly-tai-san/in-danh-sach-thanh-ly?customerName=${dataSearch.customerName}&taisanCode=${dataSearch.taisanCode}&hopdongCode=${dataSearch.hopdongCode}&tuNgay=${dataSearch.tuNgay}&denNgay=${dataSearch.denNgay}`;
  return (
    <>
      <PrintData link={link}></PrintData>
    </>
  );
};
